<script setup lang="ts">
  import { computed, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import { fmt } from '@/functions'

  const props = defineProps<{
    pagination?: Pagination,
  }>()

  const route = useRoute()
  const currentPage = computed(() => Number(route.query.hlm ?? 1))
  const lastPage = computed(() => props.pagination?.last_page ?? 1)
  const pages = computed(() => {
    const pages = [currentPage.value]
    let i = 1
    while (pages.length < 5 && pages.length < lastPage.value) {
      if (currentPage.value - i > 0) {
        pages.unshift(currentPage.value - i)
      }
      if (currentPage.value + i <= lastPage.value) {
        pages.push(currentPage.value + i)
      }
      i++
    }
    return pages
  })

  watch(currentPage, () => {
    window.scrollTo(0, 0)
  })

  const getRoute = (p: number | string) => {
    const page = p === 1 ? undefined : p
    return { query: { ...route.query, hlm: page } }
  }
</script>

<template>
  <div>
    <nav
      v-if="pagination && lastPage > 1"
      role="navigation"
      aria-label="Pagination"
      class="mt-12 flex flex-col items-center">
      <div class="mb-2 hidden text-center text-xs md:block">
        Menampilkan
        <span class="font-bold">
          {{ fmt.number(pagination.from) }}-{{ fmt.number(pagination.to) }}
        </span>
        dari
        <span class="font-bold">{{ fmt.number(pagination.total) }}</span>
      </div>
      <div class="flex justify-center">
        <router-link
          v-if="pages[0]! - 1 >= 1"
          :to="getRoute(1)"
          class="button-pagination">
          <fa-icon icon="i-far-chevrons-left" />
        </router-link>
        <router-link
          v-if="currentPage > 1"
          :to="getRoute(currentPage - 1)"
          class="button-pagination">
          <fa-icon icon="i-far-chevron-left" />
        </router-link>
        <router-link
          v-for="page in pages"
          :key="page"
          :to="getRoute(page)"
          class="button-pagination"
          :class="{
            active: Number(currentPage) === page,
          }">
          {{ fmt.number(page) }}
        </router-link>
        <router-link
          v-if="currentPage + 1 <= lastPage"
          :to="getRoute(currentPage + 1)"
          class="button-pagination">
          <fa-icon icon="i-far-chevron-right" />
        </router-link>
        <router-link
          v-if="pages[pages.length - 1]! + 1 <= lastPage"
          :to="getRoute(lastPage)"
          class="button-pagination">
          <fa-icon icon="i-far-chevrons-right" />
        </router-link>
      </div>
    </nav>
  </div>
</template>

<style lang="postcss" scoped>
  .button-pagination {
    @apply size-8 mr-1 rounded-full border bg-white text-center text-xs;
    @apply flex items-center justify-center text-gray-700 hover:bg-gray-100;
  }
  .active {
    @apply bg-primary-500 border-primary-500 hover:bg-primary-500 text-white;
  }
</style>
